import React from 'react';
import "./FinancialDashboard.css";
import QuickActions from "./QuickActions/QuickActions";
import InvoiceCard from "./InvoiceCard/InvoiceCard";
import ForecastActualCard from "./ForecastActualCard/ForecastActualCard";
import BillingExpensesPie from "./BillingExpensesPie/BillingExpensesPie";
import Transactions from "./Transactions/Transactions";

const FinancialDashboard: React.FC = () => {
  return (
    <div>
      <div className="MD-financial-details-grid">
        <div className="MD-financial-dashboard-top-section">
          <InvoiceCard />
          <ForecastActualCard />
          <BillingExpensesPie />
        </div>
      </div>
      <div className="MD-financial-dashboard-bottom-section">
        <QuickActions />
        <Transactions />
      </div>
    </div>
  );
};

export default FinancialDashboard;
